import Nullstack from 'nullstack';
export default function IconQrcode({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-qrcode",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "17",
    x2: "7",
    y2: "17.01"
  }), "   ", Nullstack.element("rect", {
    x: "14",
    y: "4",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "7",
    x2: "7",
    y2: "7.01"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "14",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "7",
    x2: "17",
    y2: "7.01"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "14",
    x2: "17",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "14",
    x2: "20",
    y2: "14.01"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "14",
    x2: "14",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "20",
    x2: "17",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "17",
    x2: "20",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "17",
    x2: "20",
    y2: "20"
  }), " ");
}